import React, { forwardRef } from 'react';

import { isString } from 'lodash';

import { Button, ButtonProps, Group, Stack, Input } from '@ui';

import classes from './ButtonSelect.module.css';

interface ButtonSelectData {
  label: string;
  value: string | boolean;
  icon?: React.ReactNode;
}

interface ButtonSelectProps extends ButtonProps {
  label?: string | React.ReactNode;
  data: ButtonSelectData[];
  value?: string | boolean;
  onChange?: (value: string | boolean) => void;
  error?: string;
  disabled?: boolean;
}

const ButtonSelect = forwardRef<HTMLDivElement, ButtonSelectProps>(
  ({ data, value, onChange, label, error, disabled, ...rest }, ref) => {
    const handleChange = (val: string | boolean) => {
      onChange?.(val);
    };

    return (
      <Stack gap="0" ref={ref} w="100%">
        {/* LabelWithInfo handles required `*` with in LabelWithInfo so add required arg only for string labels here */}
        {label && <Input.Label required={isString(label)}>{label}</Input.Label>}
        <Group w="100%" gap="md" wrap="nowrap">
          {data.map((item, index) => (
            <Button
              mod={{ selected: item.value === value }}
              key={`${item.value}-${index}`}
              {...rest}
              variant={item.value === value ? 'light' : 'outline'}
              color={item.value === value ? 'primary' : 'secondary'}
              leftSection={item?.icon}
              onClick={() => handleChange(item.value)}
              radius="xs"
              miw={{ base: 'auto', sm: 132 }}
              disabled={disabled}
              fullWidth
              classNames={{ root: classes.root }}
            >
              {item.label}
            </Button>
          ))}
        </Group>
        {error && <Input.Error mt="xs">{error}</Input.Error>}
      </Stack>
    );
  }
);

export { ButtonSelect, type ButtonSelectData, type ButtonSelectProps };
